import { useParams } from 'react-router-dom'
import { ListKeys, menuList, modulesList } from '../../../api/list'
import { FormBuilderContainer } from '../../../components/formBuilder/formBuilder.container'
import { FormItemTypes, IFormBuilder, ValueTypes } from '../../../components/formBuilder/formBuilder.entity'
import { createFeature, getFeaturebyId, updateFeature } from './apiCall'
import { FeaturesKeys } from './entity'

export default function FeaturesEdit() {
  let { id } = useParams();

  const formData: IFormBuilder['formData'] = [
    {
      type: FormItemTypes.TextInput,
      name: 'Name',
      label: 'Name',
      value: null,
      required: true,
      maxLength: 100,
      valueTypes: ValueTypes.onlyAlphabets
    },
    {
      type: FormItemTypes.TextInput,
      name: 'DisplayName',
      label: 'Display Name',
      value: null,
      required: true,
      maxLength: 100,
      valueTypes: ValueTypes.onlyAlphabets
    },
    {
      type: FormItemTypes.SearchSelect,
      name: 'ModuleId',
      label: 'Module',
      value: null,
      displayExpr: "DisplayName",
      valueExpr: "id",
      getListData: modulesList,
      apiKey: ListKeys.modules,
      required: true,
      disabled: !!id
    },
    {
      type: FormItemTypes.SearchSelect,
      name: 'MenuId',
      label: 'Menu',
      value: null,
      displayExpr: "Name",
      valueExpr: "id",
      getListData: menuList,
      apiKey: ListKeys.menu,
      required: true,
      // disabled: !!id
    },
  ]

  return (
    <FormBuilderContainer
      formData={formData}

      getFormAPI={getFeaturebyId}
      getRequest={{ id: id }}
      getKey={FeaturesKeys.get}

      createFormAPI={createFeature}
      createKey={FeaturesKeys.create}

      updateFormAPI={updateFeature}
      updateKey={FeaturesKeys.update}

      headerLabel={!id ? 'Add Feature' : 'Feature'}
      parentPath={'/feature'}
    />
  )
}